import { render, staticRenderFns } from "./InviteSettings.vue?vue&type=template&id=0134fc7e&"
import script from "./InviteSettings.vue?vue&type=script&lang=ts&"
export * from "./InviteSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports